<template>
  <div
    :class="['form-element', hidden && 'd-none']"
    :data-test="dataTest"
  >
    <template v-if="disabled">
      <FormInputButton
        :disabled="true"
        :label="label"
        :required="required"
        :error="error"
        :dirty="dirty"
      >
        {{ displayDate }}
      </FormInputButton>
    </template>
    <template v-else>
      <FormLabel
        v-if="label"
        v-bind="{
          label,
          required,
          disabled,
          description,
          descriptionType,
          dirty,
          error,
          id,
          status
        }"
      />
      <CommonDatepicker
        :id="id"
        :value="date"
        type="date"
        :use-utc="false"
        :typeable="mergedConfig.typeable"
        :placeholder="disabled ? '—' : placeholder"
        :disabled="disabled"
        :input-class="{
          'p-0': disabled,
          'form-control datepicker': true,
          'invalid': invalid && dirty,
          'bg-white': !disabled
        }"
        v-bind="mergedConfig"
        @input="update"
        @blur="$emit('blur')"
      />
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import CommonDatepicker from '@/components/Common/CommonDatepicker'
import { DB_DATE } from '@/constants/'
import FormMixin from './FormMixin'
import FormLabel from './FormLabel'
import FormInputButton from './FormInputButton'

export default {
  mixins: [ FormMixin ],
  components: { CommonDatepicker, FormLabel, FormInputButton },
  props: {
    value: {
      type: String,
      default: '',
    },
    formValue: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    mergedConfig () {
      return {
        typeable: true,
        format: DB_DATE,
        // Historically we always displayed 'll' as format
        // and that couldn't be changed with config.
        // In some cases however (e.g SectionTimes.vue),
        // we want to display different format.
        displayFormat: 'll',
        ...this.config,
        disabledDates: this.getReferencedDates(this.config.disabledDates),
        highlighted: this.getReferencedDates(this.config.highlighted),
      }
    },
    date () {
      return this.value ? moment.utc(this.value).toDate() : this.value
    },
    dateFormat () {
      if (this.mergedConfig.format === 'iso') return moment.defaultFormatUtc
      return this.mergedConfig.format
    },
    displayDate () {
      return this.date
        ? moment.utc(this.date).format(this.mergedConfig.displayFormat)
        : ''
    },
  },
  methods: {
    getReferencedDates (referencedDates = {}) {
      return Object.keys(referencedDates).reduce((datesObj, key) => {
        const dateValueOrKey = referencedDates[key]

        if (typeof dateValueOrKey === 'string' && dateValueOrKey.startsWith('$$')) {
          const referenceKey = dateValueOrKey.split('$$')[1]

          if (!this.formValue[referenceKey]) return datesObj

          return {
            ...datesObj,
            [key]: moment(this.formValue[referenceKey]).toDate(),
          }
        } else {
          return {
            ...datesObj,
            [key]: dateValueOrKey,
          }
        }
      }, {})
    },
    update (value) {
      if (!value && !this.value) return
      if (!moment.utc(value).isValid()) return this.$emit('input', '')
      if (!value) return this.$emit('input', '')
      return this.$emit('input', moment.utc(value).format(this.dateFormat))
    },
  },
}
</script>

<style scoped>
.row .col:first-child {
  padding-left: 0;
}
.row .col:nth-child(2) {
  padding: 0;
}
.row .col:last-child {
  padding-right: 0;
}

.form-control {
  height: 36px;
  min-width: 168px;
}
.form-element >>> .datepicker {
  background-image: none;
  height: 36px;
}
</style>
